import Vue from 'vue';
import Router from 'vue-router';
import Set from '@/components/Set';
// import Form from '@/components/form/Index';
// import Edit from '@/components/Edit';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/set/' : '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Set
    },
    {
      path: '/:id',
      name: 'Set',
      component: Set
    }
    // ,
    // {
    //   path: '/form',
    //   name: 'Form',
    //   component: Form
    // }
    // ,
    // {
    //   path: '/:id/edit',
    //   name: 'Edit',
    //   component: Edit
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js